import { takeLatest } from "redux-saga/effects";
import {
  allSubscriptionAction,
  subscribeAction,
  totalSubscriberAction,
  unsubscribeAction,
} from "./slices";
import { isSubscribedAction } from "./slices/isSubscribed";
import {
  allSubscriptionWorker,
  subscribeWorker,
  totalSubscriberWorker,
  unsubscribeWorker,
} from "./workers";
import { isSubscribedWorker } from "./workers/isSubscribed";

const subscriptionWatcher = [
  takeLatest(allSubscriptionAction, allSubscriptionWorker),
  takeLatest(unsubscribeAction, unsubscribeWorker),
  takeLatest(subscribeAction, subscribeWorker),
  takeLatest(totalSubscriberAction, totalSubscriberWorker),
  takeLatest(isSubscribedAction, isSubscribedWorker),
];

export default subscriptionWatcher;
